/*
 * @Description: 项目相关
 * @Date: 2025-03-03 11:38:40
 */
/**
 * 交易结构：1 汇总申报，3 委托代发，4 运营基地，5 个体产品，6 委托代开
 */
export enum TaxPatternEnum {
  one = 1, // 汇总申报
  three = 3, // 委托代发
  four = 4, // 运营基地
  five = 5, // 个体产品
  six = 6 // 委托代开
}

/**
 * 参与方
 */
export const patternTypeMapping = {
  1: { label: '工业-ASP-P-C', value: 1 },
  2: { label: '工业-P-C', value: 2 },
  // 3: { label: 'ASP-P-C', value: 3 },
  4: { label: '工业-ASP-C', value: 4 },
  5: { label: '工业-C', value: 5 },
  // 6: { label: 'ASP-C', value: 6 },
  // 7: { label: '工业-运营基地-C', value: 7 },
  7: { label: '工业-ASP-C', value: 7 },
  // 8: { label: 'ASP-运营基地-C ', value: 8 },
  // 9: { label: '运营基地-C', value: 9 },
  10: { label: '工业-ASP-个体', value: 10 },
  11: { label: '工业-个体', value: 11 }
  // 12: { label: 'ASP-个体', value: 12 },
  // 13: { label: '工业-ASP（线下支付）-P-C', value: 13 },
  // 14: { label: '工业（线下支付）-P-C', value: 14 }
};

/**
 * 交易结构：1 汇总申报（工业-ASP-P-C，工业-P-C），4 运营基地（工业-运营基地-C），3 委托代发（工业-ASP-P-C，工业-P-C），6 委托代开（工业-ASP-C，工业-C），5 个体产品（工业-ASP-个体，工业-个体）
 */
export const taxPatternMapping: Record<
  TaxPatternEnum,
  {
    value: TaxPatternEnum;
    label: string;
    patternsMapping: Record<
      number,
      {
        value: number;
        label: string;
      }
    >;
  }
> = {
  [TaxPatternEnum.one]: {
    value: TaxPatternEnum.one,
    label: '汇总申报',
    patternsMapping: {
      1: patternTypeMapping[1],
      2: patternTypeMapping[2]
    }
  },
  [TaxPatternEnum.four]: {
    value: TaxPatternEnum.four,
    label: '运营基地',
    patternsMapping: {
      7: patternTypeMapping[7],
      5: patternTypeMapping[5]
    }
  },
  [TaxPatternEnum.three]: {
    value: TaxPatternEnum.three,
    label: '委托代发',
    patternsMapping: {
      1: patternTypeMapping[1],
      2: patternTypeMapping[2]
    }
  },
  [TaxPatternEnum.six]: {
    value: TaxPatternEnum.six,
    label: '委托代开',
    patternsMapping: {
      4: patternTypeMapping[4],
      5: patternTypeMapping[5]
    }
  },
  [TaxPatternEnum.five]: {
    value: TaxPatternEnum.five,
    label: '个体产品',
    patternsMapping: {
      10: patternTypeMapping[10],
      11: patternTypeMapping[11]
    }
  }
};

/**
 * 交易结构：1 汇总申报（工业-ASP-P-C，工业-P-C），4 运营基地（工业-运营基地-C），3 委托代发（工业-ASP-P-C，工业-P-C），6 委托代开（工业-ASP-C，工业-C），5 个体产品（工业-ASP-个体，工业-个体）
 */
export const taxPatternArr = [
  {
    value: TaxPatternEnum.one,
    label: '汇总申报',
    patternsArr: [patternTypeMapping[1], patternTypeMapping[2]]
  },
  {
    value: TaxPatternEnum.four,
    label: '运营基地',
    patternsArr: [patternTypeMapping[7]]
  },
  {
    value: TaxPatternEnum.three,
    label: '委托代发',
    patternsArr: [patternTypeMapping[1], patternTypeMapping[2]]
  },
  {
    value: TaxPatternEnum.six,
    label: '委托代开',
    patternsArr: [patternTypeMapping[4], patternTypeMapping[5]]
  },
  {
    value: TaxPatternEnum.five,
    label: '个体产品',
    patternsArr: [patternTypeMapping[10], patternTypeMapping[11]]
  }
];

/**
 * 场景类型：6：数字专区（专区+资讯），21：数字问卷（专区+资讯+表单），17：数字拜访（专区+资讯+目标题+固定字段），5：调研问卷（表单），20：可配置（表单+目标题+风控题），19：协定服务（固定字段+特殊计价）
 */
export enum SceneTypeEnum {
  six = 6,
  twentyOne = 21,
  seventeen = 17,
  five = 5,
  twenty = 20,
  nineteen = 19
}

/** 发起项目 / 智能表单：仅允许选择的一级场景（可配置、调研问卷、数字问卷） */
export const ALLOWED_SCENE_ROOT_TYPES: SceneTypeEnum[] = [
  SceneTypeEnum.twenty,
  SceneTypeEnum.five,
  SceneTypeEnum.twentyOne
];

/**
 * 场景类型：6：数字专区（专区+资讯），21：数字问卷（专区+资讯+表单），17：数字拜访（专区+资讯+目标题+固定字段），5：调研问卷（表单），20：可配置（表单+目标题+风控题），19：协定服务（固定字段+特殊计价）
 */
export const sceneTypeMapping = {
  [SceneTypeEnum.six]: { label: '数字专区', value: SceneTypeEnum.six },
  [SceneTypeEnum.twentyOne]: {
    label: '数字问卷',
    value: SceneTypeEnum.twentyOne
  },
  [SceneTypeEnum.seventeen]: {
    label: '数字拜访',
    value: SceneTypeEnum.seventeen
  },
  [SceneTypeEnum.five]: {
    label: '调研问卷',
    value: SceneTypeEnum.five
  },
  [SceneTypeEnum.twenty]: {
    label: '可配置',
    value: SceneTypeEnum.twenty
  },
  [SceneTypeEnum.nineteen]: {
    label: '协定服务',
    value: SceneTypeEnum.nineteen
  }
};

/**
 * 劳务类型：1经营类， 2劳务类 一般劳务， 3劳务类 连续劳务
 */
export const taxTypeMapping = {
  1: {
    value: 1,
    label: '经营类'
  },
  2: {
    value: 2,
    label: '一般劳务'
  },
  3: {
    value: 3,
    label: '连续劳务'
  }
};

/**
 * 劳务类型综合类型：1经营类， 2劳务类
 */
export const taxBroadTypeMapping = {
  1: {
    value: 1,
    label: '经营类'
  },
  2: {
    value: 2,
    label: '劳务类'
  }
};

/** 字典类型码表（dictDataList 接口 dictType 入参） */
export const DICT_TYPE = {
  apply_product: { label: '适用产品', value: 'apply_product' },
  service_object: { label: '服务对象', value: 'service_object' },
  lifecycle_stage: { label: '产品生命周期', value: 'lifecycle_stage' },
  product_category: { label: '药品类别', value: 'product_category' },
  product_attribute: { label: '产品属性', value: 'product_attribute' },
  instrument_product_category: {
    label: '医疗器械产品类别',
    value: 'instrument_product_category'
  },
  instrument_product_attribute: {
    label: '医疗器械产品属性',
    value: 'instrument_product_attribute'
  },
  terminal_channel: { label: '终端渠道', value: 'terminal_channel' },
  is_ai_enabled: { label: '固定字段是否AI发挥', value: 'is_ai_enabled' },
  medical_rep_tag: { label: '医药代表备案标签', value: 'medical_rep_tag' },
  target_customer: { label: '客户目标', value: 'target_customer' },
  product_type: { label: '业务类型', value: 'product_type' },
  filing_type: { label: '备案身份', value: 'filing_type' },
  risk_level: { label: '风险等级', value: 'risk_level' },
  question_type: { label: '题目类型', value: 'question_type' },
  pre_scene_scenario: { label: '前置场景', value: 'pre_scene_scenario' },
  rear_scene: { label: '后续场景', value: 'rear_scene' }
} as const;
